<script>
	import { createEventDispatcher } from 'svelte';
	export let type = 'checkbox';
	export let checked = false;
	export let group = '';
	export let value = void 0;
	export let disabled = false;
	export let buttonLabel = '';
	export let buttonPrice = false;
	export let price = 0;
	export let classes = '';
	export let id = null;
	export let index = null;

	const dispatch = createEventDispatcher();

	$: type === 'radio' && updateRadio(group, value)
	$: type === 'checkbox' && group && updateCheckbox(group, value)
	$: type === 'checkbox' && group && updateGroup(checked, value)

	function handleClick() {
		if(type == 'radio') {
			group = value;
		}
		else {
			checked ? checked = false : checked = true;
		}
		//console.log(id, index);
		dispatch('toggle', {id: id, index: index});
	}
	
	function updateRadio(group, value) {
		checked = group === value
	}	
	
	function updateCheckbox(group, value) {
		checked = group.indexOf(value) >= 0
	}
	
	function updateGroup(checked, value) {
		const index = group.indexOf(value)
		if (checked) {
			if (index < 0) {
				group.push(value)
				group = group
			}
		} else {
			if (index >= 0) {
				group.splice(index, 1)
				group = group
			}
		}
	}

	function formatPrice(num){
		let formatter = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
			minimumFractionDigits: 0
		});

		return formatter.format(num);
	}
</script>

<button disabled={disabled} class:disabled={disabled} class="button {classes}" class:active={checked} on:click={handleClick}>
	
	<div class="buttonLabel">{buttonLabel}</div>
	{#if buttonPrice}
		<div class="buttonPrice">
		{#if price === 0}
			included
		{:else}
			+{formatPrice(price)}
		{/if}
		</div>
	{/if}

	{#if type === 'radio'}
		<input
			type="radio"
			class="collapsed"
			on:click
			bind:group={group}
			value={value}
			style="display: none"
		/>
	{:else}
		<input
			type="checkbox"
			class="collapsed"
			on:click
			bind:checked={checked}
			value={value}
			style="display: none"
		/>
	{/if}
</button>

<style>
	.button {
		@apply rounded-full border-4 w-full px-12 py-4;
		font-family: Camphor W01 Bold;
		box-shadow: none;
		outline: none;
	}

	.button:not(.disabled).active:focus {
		@apply border-blue-500 !important;
		box-shadow: 0 0 5px rgba(81, 203, 238, 1);
	}

	.button:not(.disabled):hover {
		@apply border-gray-500 transition duration-100 ease-in;
	}

	.button.active, .button.active:hover {
		@apply border-blue-500;
	}

	.button.disabled, .button.disabled:hover {
		cursor: default;
		@apply opacity-50;
		border-color: transparent;

		background: repeating-linear-gradient(
			-45deg,
			#C6C6C6,
			#C6C6C6 2px,
			#DCDCDC 2px,
			#DCDCDC 10px
		);
	}

	.buttonLabel {
		font-family: Camphor W01 Bold;
	}

	.buttonPrice {
		@apply text-gray-600 text-base;
		font-family: Camphor W01 Regular;
	}
</style>